export interface openOreStartInterface{
    //id
    id:number,
    //图标
    icon:string,
    //木头名字
    stoneName:string,
    //档位
    gear:number,
    //重量
    weight:number,
    //描述
    explain:string,
    //价格
    price:number,
    /** 价格倍率 */
    priceRate: number,
    //绑定的背包物体id
    bindBackId:number,
    //事件和事件概率
    incidents:openOreEventInterface[],
    //第一刀X的位置
    onePosX:number,
    //第一刀Y的位置
    onePosY:number,
    //第二刀Y的位置
    twoPosY:number,
    //第二刀X的未知
    twoPosX:number
}

export interface openOreEventInterface{
    //事件id
    endId:string,
    //权重
    weight:number
}

export interface openOreEndInterface{
    //id
    id:string,
    //后续  //为空则没有后续
    incidents:openOreEventInterface[],
    //属性
    param:{[name:string]:any},
    //切开后图片
    incision:string,
    //文案描述
    describe:string,
    //价格
    price:number,
}

export interface openOreStartMap{
    [id:number] : openOreStartInterface;
}

export interface openOreEndMap{
    [id:number] : openOreEndInterface 
}

/** 女娲石收集 */
export const OpenOreSpecialCollect = [50001, 50002, 50003, 50004, 50005];

export enum OpenOreDataSaveType {
    OPEN_ORE_SAVE_KEY = 'open-ore-save-key',
    OPEN_ORE_DAT_SAVE_KEY = 'open-ore-dat-save-key',
    OPEN_ORE_CUT_KEY = 'open-ore-cut-key',
    OPEN_ORE_CUTCOUNT_DAY_KEY = 'open-ore-cutcount-day-key',
}